/**
 * Tribe community widgets.
 * https://docs.tribe.so/#widgets
 */
import { isProdSite, isRcSite, isDevSite, isLocalHost } from '@/helpers/deployment.js';

// static Tribe community url
export const TribeCommunityUrl =

    /**  //dev.taide*,  //localhost
      **/
    ((isDevSite || isLocalHost)
    && 'https://taidedev.tribe.so')


    /**  //taide.art/,  //rc.taide*,  //testi.taide*
      **/
    || ((isProdSite || isRcSite)
    && 'https://community.taide.art');


export const TribePlugin = {
    name: 'tribe',

    TribeCommunityUrl,

    install (Vue) {
        /**
         * Vue component wrapper for window.Tribe.
         */
        Vue.component('tribe-widget', () => import('@/components/Tribe/TribeWidget.vue'));
    }
};

export default TribePlugin;
